import React, { useEffect, useState } from "react";
import { IoIosSearch } from "react-icons/io";
import { LuPlus } from "react-icons/lu";
import { Eye } from "lucide-react";
import { CiEdit } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosinstance";
import "./Table.css";

function Checklist({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const [checklists, setChecklists] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [role, setRole] = useState("");
  useEffect(() => {
    const storedRole = localStorage.getItem("user_role");
    if (storedRole) {
      setRole(storedRole);
    }
  }, []);
  useEffect(() => {
    const fetchChecklists = async () => {
      setLoading(true);
      setError("");

      try {
        const response = await axiosInstance.get("/api/get_checklists", {
          params: {
            search: searchQuery.trim() || undefined,
          },
        });

        const records = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data?.data)
          ? response.data.data
          : [];

        setChecklists(records);
      } catch (err) {
        console.error("Error fetching checklists:", err);
        setChecklists([]);
        setError("Failed to load checklists");
      } finally {
        setLoading(false);
      }
    };

    fetchChecklists();
  }, [searchQuery]);

  return (
    <div
      className={`table-container checklist-page ${isSidebarExpanded ? "expanded" : "collapsed"
        }`}
    >
      <div className="table-container-content checklist-content">
        <div className="table-header">
          <div className="table-header-content">
            <div className="table-left-side">
              <h2 className="jost-bold">Checklist</h2>
            </div>
            <div className="table-right-side">
              <div className="search-bar-container">
                <input
                  type="text"
                  placeholder="Search ..."
                  className="search-bar"
                  value={searchQuery}
                  onChange={(event) => setSearchQuery(event.target.value)}
                />
                <IoIosSearch className="search-bar-icon" />
              </div>
              {role === "Super Admin" && (<div
                className="new-button"
                onClick={() => navigate("/checklist-form")}
              >
                <span className="new-icon">
                  <LuPlus />
                </span>
                <span>New</span>
              </div>)}
            </div>
          </div>
        </div>

        <div className="data-list-body checklist-data-body">
          <div className="data-list-scroll-body checklist-scroll-body">
            {/* <div className="data-list-table"> */}
              <table className="table multilevel-data checklist-table">
                <thead className="sticky-header">
                  <tr className="table-row">
                    <th className="center-align">Sr. No</th>
                    <th className="checklist-template-header">Template Name</th>
                    <th className="center-align">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="3" className="no-data-text">
                        Loading checklists...
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="3" className="no-data-text">
                        {error}
                      </td>
                    </tr>
                  ) : checklists.length > 0 ? (
                    checklists.map((checklist, index) => (
                      <tr
                        className="hoverable-row"
                        key={checklist.checklist_id || index}
                      >
                        <td className="center-align">{index + 1}</td>
                        <td className="checklist-template-cell">
                          {checklist.checklist_name
                            ? checklist.checklist_name
                            : "-"}
                        </td>
                        <td className="center-align checklist-action-cell">
                          <div className="action-btn">
                            <span
                              className="action-icon"
                              onClick={() =>
                                navigate(
                                  `/checklist-view/${checklist.checklist_id}`
                                )
                              }
                            >
                              <Eye size={18} color="gray" />
                            </span>
                           {role === "Super Admin" && ( <span
                              className="action-icon"
                              onClick={() =>
                                navigate(
                                  `/edit-checklist/${checklist.checklist_id}`
                                )
                              }
                            >
                              <CiEdit size={18} color="gray" />
                            </span> )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="no-data-text">
                        No checklists found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Checklist;
